import React from 'react';
import './NoResultsAnimation.css';

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Box } from '@mui/material';

export type NoResultsAnimationProps = {
    logoSrc?: string;
    message?: string;
    size?: number;
};

const NoResultsAnimation: React.FC<NoResultsAnimationProps> = ({
    logoSrc,
    message = 'NO RESULTS FOUND',
    size = 120,
}) => {
    const coreSize = Math.round(size * 0.666);

    const styleVars: React.CSSProperties = {
        ['--size' as any]: `${size}px`,
        ['--core-size' as any]: `${coreSize}px`,
    };

    return (
        <div
            className='noresults-root'
            style={styleVars}
            role='status'
            aria-live='polite'
            aria-label={`${message}`}
        >
            <div className='noresults-container'>
                <DotLottieReact
                    src='https://lottie.host/b5ddf9e1-fc80-4cd0-8f9d-af6fec84ba48/4Jpj7ZOefM.lottie'
                    loop
                    autoplay
                />

                <div className='noresults-text'>{message}</div>
                <div className='noresults-sub'>Try adjusting your filters</div>
            </div>
        </div>
    );
};

export default NoResultsAnimation;
